"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValuesCell = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const attribute_values_cell_styles_1 = require("./attribute-values-cell.styles");
const consolidated_list_1 = require("../../../consolidated-list");
const AttributeValuesCell = ({ className, align = 'left', expanded, attributeValues = [], }) => {
    const filteredValues = attributeValues.filter(({ name }) => name);
    return (react_1.default.createElement(attribute_values_cell_styles_1.StyledAttributeValuesCell, { className: className, align: align }, (!expanded || filteredValues.length === 0) && react_1.default.createElement(consolidated_list_1.AttributeValue, { values: filteredValues }), expanded && filteredValues.map(({ id, name }) => (react_1.default.createElement(react_1.default.Fragment, { key: id }, react_1.default.createElement("div", { key: id, className: (0, classnames_1.default)('attribute-values-container') }, name))))));
};
exports.AttributeValuesCell = AttributeValuesCell;
exports.default = exports.AttributeValuesCell;
